
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/Bitcoin",
      function () {
        return require("private-next-pages/money-fortune/Bitcoin.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/Bitcoin"])
      });
    }
  